import { Avatar, Box, ListItem, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { IResult } from '..';
import { useIsDesktop } from 'Hooks';
import { Loader } from 'Components/Loader';
import { PurpleDownloadIcon } from 'Images';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { sendEvent } from 'Utils/sendEvent';

interface IResultItem {
  item: IResult;
}

export const ResultItem = ({ item }: IResultItem) => {
  const [isLoading, setIsLoading] = useState(false);

  const isDesktop = useIsDesktop();

  const onClickDownload = async (resultItem: IResult) => {
    if (!resultItem.onClick) return;

    setIsLoading(true);
    sendEvent('Search Page', 'SearchDownload');
    await resultItem.onClick();
    setIsLoading(false);
  };

  return (
    <ListItem sx={{ p: 0 }}>
      <Stack
        tabIndex={0}
        role='link'
        flexDirection={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
        maxWidth={'560px'}
        width='fit-content'
        onClick={() => onClickDownload(item)}
        sx={{
          cursor: 'pointer',
        }}
      >
        <Typography
          onClick={() => onClickDownload(item)}
          sx={{
            fontSize: '20px',
            fontWeight: '400 !important',
            textDecorationLine: 'underline',
            lineHeight: '28px',
            maxWidth: isDesktop ? 'fit-content' : undefined,
          }}
          key={item.label}
          color={'#1552E8'}
        >
          {item.label}
        </Typography>
        {item.isDownload &&
          (isLoading ? (
            <Box
              sx={{
                width: '22px',
                height: '22px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mr: '38px',
              }}
            >
              <Loader size={22} />
            </Box>
          ) : (
            <Stack
              flexDirection={'row'}
              gap={'4px'}
              maxWidth={'min-content'}
              mr='14px'
            >
              <Avatar
                sx={{ width: '20px', height: '20px' }}
                src={PurpleDownloadIcon}
                alt=''
              />
              <Typography variant='body6'>
                {Dictionary[DICTIONARY.General].downloadShort}
              </Typography>
            </Stack>
          ))}
      </Stack>
    </ListItem>
  );
};
